// extracted by mini-css-extract-plugin
export var container = "styles-module__container___lRFis";
export var opacScreen = "styles-module__opacScreen___j1A8w";
export var tray = "styles-module__tray___djIE1";